export default __webpack_public_path__ + "static/media/Hen.2adf8176.jpg";